import { Facebook, Instagram } from "lucide-react";
import { CLINIC } from "@/data/services";

export const TikTokIcon = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const SocialLinks = ({ light = false }) => {
  const linkCls = light
    ? "text-slate-700 hover:text-red-700"
    : "text-slate-300 hover:text-red-400";
  const iconCls = light
    ? "bg-red-100 text-red-700 group-hover:bg-red-600 group-hover:text-white"
    : "bg-red-600/20 text-red-400 group-hover:bg-red-600 group-hover:text-white";
  const subCls = light ? "text-slate-500" : "text-slate-500";

  return (
    <div className="flex flex-col gap-3">
      <a
        data-testid="social-facebook-link"
        href={CLINIC.facebook}
        target="_blank"
        rel="noopener noreferrer"
        className={`group flex items-center gap-3 text-sm transition-colors ${linkCls}`}
      >
        <span
          className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full transition-colors ${iconCls}`}
        >
          <Facebook size={16} />
        </span>
        <span>
          <span className="block font-medium">Facebook</span>
          <span className={`block text-xs ${subCls}`}>
            Ecocore DX Ecografía y Diagnóstico
          </span>
        </span>
      </a>
      <a
        data-testid="social-instagram-link"
        href={CLINIC.instagram}
        target="_blank"
        rel="noopener noreferrer"
        className={`group flex items-center gap-3 text-sm transition-colors ${linkCls}`}
      >
        <span
          className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full transition-colors ${iconCls}`}
        >
          <Instagram size={16} />
        </span>
        <span>
          <span className="block font-medium">Instagram</span>
          <span className={`block text-xs ${subCls}`}>
            @consultoriomedicoecocore
          </span>
        </span>
      </a>
      <a
        data-testid="social-tiktok-link"
        href={CLINIC.tiktok}
        target="_blank"
        rel="noopener noreferrer"
        className={`group flex items-center gap-3 text-sm transition-colors ${linkCls}`}
      >
        <span
          className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full transition-colors ${iconCls}`}
        >
          <TikTokIcon size={15} />
        </span>
        <span>
          <span className="block font-medium">TikTok</span>
          <span className={`block text-xs ${subCls}`}>
            ECOCORE DX Ecografía y Diagnóstico
          </span>
        </span>
      </a>
    </div>
  );
};

export default SocialLinks;
